/**
 * Unified Role-based Access Control (RBAC)
 * Distinguishes between Internal Application roles and Customer Team roles.
 */

export const SYSTEM_ROLES = {
  ADMIN: 'admin',      // Can manage app, CMS, all users, and billing
  MANAGER: 'manager',  // Can view user data, team metrics, and reports
  VIEWER: 'viewer',    // Read-only access to global stats
  USER: 'user'         // Standard customer account
};

export const TEAM_ROLES = {
  OWNER: 'owner',      // Can manage company billing and all team members
  ADMIN: 'admin',      // Can invite members and deploy assessments
  MEMBER: 'member',    // Can take assigned assessments and view shared reports
  GUEST: 'guest'       // Read-only access to specific shared items
};

export const PERMISSIONS = {
  // Internal Staff Permissions
  MANAGE_CMS: 'manage_cms',
  VIEW_ALL_COMPANIES: 'view_all_companies',
  MANAGE_SYSTEM_USERS: 'manage_system_users',
  
  // Customer Team Permissions
  INVITE_TEAM: 'invite_team',
  DEPLOY_ASSESSMENT: 'deploy_assessment',
  MANAGE_TEAM_ROLES: 'manage_team_roles',
  VIEW_TEAM_REPORTS: 'view_team_reports',
  PURCHASE_ASSESSMENTS: 'purchase_assessments'
};

const SYSTEM_ROLE_PERMISSIONS = {
  [SYSTEM_ROLES.ADMIN]: [
    PERMISSIONS.MANAGE_CMS,
    PERMISSIONS.VIEW_ALL_COMPANIES,
    PERMISSIONS.MANAGE_SYSTEM_USERS,
    PERMISSIONS.VIEW_TEAM_REPORTS
  ],
  [SYSTEM_ROLES.MANAGER]: [
    PERMISSIONS.VIEW_ALL_COMPANIES,
    PERMISSIONS.VIEW_TEAM_REPORTS
  ],
  [SYSTEM_ROLES.VIEWER]: [
    PERMISSIONS.VIEW_ALL_COMPANIES
  ],
  [SYSTEM_ROLES.USER]: []
};

const TEAM_ROLE_PERMISSIONS = {
  [TEAM_ROLES.OWNER]: [
    PERMISSIONS.INVITE_TEAM,
    PERMISSIONS.DEPLOY_ASSESSMENT,
    PERMISSIONS.MANAGE_TEAM_ROLES,
    PERMISSIONS.VIEW_TEAM_REPORTS,
    PERMISSIONS.PURCHASE_ASSESSMENTS
  ],
  [TEAM_ROLES.ADMIN]: [
    PERMISSIONS.INVITE_TEAM,
    PERMISSIONS.DEPLOY_ASSESSMENT,
    PERMISSIONS.VIEW_TEAM_REPORTS
  ],
  [TEAM_ROLES.MEMBER]: [
    PERMISSIONS.VIEW_TEAM_REPORTS
  ],
  [TEAM_ROLES.GUEST]: []
};

export const hasSystemPermission = (role, permission) => {
  return SYSTEM_ROLE_PERMISSIONS[role]?.includes(permission) || false;
};

export const hasTeamPermission = (role, permission) => {
  return TEAM_ROLE_PERMISSIONS[role]?.includes(permission) || false;
};